import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export function extractArticleIdFromUrl(url) {
  if (!url || typeof url !== "string") return null;

  try {
    // Method 1: URLs ending with -ID.html (most common)
    const htmlMatch = url.match(/-(\d+)\.html$/i);
    if (htmlMatch) {
      return htmlMatch[1];
    }

    // Method 2: URLs ending with -ID (without .html) — Gujarati Jagran style
    const dashMatch = url.match(/-(\d+)$/);
    if (dashMatch) {
      return dashMatch[1];
    }

    // Method 3: Fallback — look for any 6–10 digit number near the end
    const numbers = url.match(/\d+/g);
    if (numbers) {
      // Find the last number that looks like an article ID (usually 6–10 digits)
      const candidates = numbers
        .filter(n => n.length >= 6 && n.length <= 10)
        .reverse(); // start from the end

      if (candidates.length > 0) {
        return candidates[0];
      }
    }

    return null;
  } catch (e) {
    console.error("Error extracting article ID:", e);
    return null;
  }
}
export function convertToIst(timestampMillis) {
    const date = new Date(timestampMillis);

    const options = {
        timeZone: 'Asia/Kolkata', // The official time zone identifier for IST
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // Use 24-hour format
        timeZoneName: 'short' // Include the timezone name (e.g., "IST")
    };

   
    const istTime = date.toLocaleString('en-IN', options);

    return istTime;
}